import { useCallback, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TableConfigProvider,
  type TableError,
} from '@repo/ui/lib/table-config';
import { SKIP, TAKE } from '@/lib/constants/pagination';
import { getErrorMessage } from '@/lib/utils/error-handler';

const PAGINATION = { skip: SKIP, take: TAKE };

/**
 * Configurazione delle tabelle di `@repo/ui` per la webapp: paginazione
 * dell'API e messaggi d'errore. L'importo della selezione lo rende il
 * package (`SignedAmount`).
 */
export function WebTableConfigProvider({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const formatError = useCallback(
    (error: TableError) => getErrorMessage(error, t),
    [t]
  );

  return (
    <TableConfigProvider pagination={PAGINATION} formatError={formatError}>
      {children}
    </TableConfigProvider>
  );
}
